import {
  apiClient,
  type PageEntity,
  type PackageCategoryEntity
} from '@/libs/api'
import type { PackageCategoriesListRequestQuery } from '@/libs/api/types'

export type FetchPackageCategoriesListQuery = {
  tenantKey: string
  query?: PackageCategoriesListRequestQuery
}

export type FetchPackageCategoriesListResponse = {
  data: PackageCategoryEntity[]
  pagination: PageEntity | null
}

/**
 * 荷姿一覧を取得
 */
export const fetchPackageCategoriesList = async (
  { tenantKey, query }: FetchPackageCategoriesListQuery,
  signal?: AbortSignal
): Promise<FetchPackageCategoriesListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .package_categories.list.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
